var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningSymbolWarningMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-4 {\n        isolation: isolate;\n      }\n\n      .cls-5 {\n        fill: #cc2e2e;\n        fill-rule: evenodd;\n      }\n\n      .cls-6 {\n        mix-blend-mode: overlay;\n        opacity: .36;\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath-2);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -2360.5,
    y: -1170.5,
    width: 1920,
    height: 1080
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -91.5,
    y: -1170.5,
    width: 1920,
    height: 1080
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -91.5,
    y: 71.5,
    width: 1920,
    height: 1080
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Exercise_1.1",
    "data-name": "Exercise 1.1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background-2",
    "data-name": "Background"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.01,40.48H1.09v-10.05h1.78v8.03h4.62v-6.97h1.78v6.97h6.73v2.03ZM12.61,28.32l-.16-1.78c.81-.16,1.38-.41,1.78-.81.41-.41.57-.97.57-1.62,0-.57-.16-1.05-.41-1.46-.24-.49-.57-.81-1.05-1.05-.41-.32-.97-.49-1.7-.73-.73-.16-1.46-.24-2.27-.24h-.32c.57.41,1.05.89,1.38,1.54.41.57.57,1.3.57,2.03,0,1.22-.49,2.27-1.38,3.08-.89.89-2.03,1.3-3.49,1.3-1.54,0-2.76-.41-3.65-1.3-.97-.89-1.38-2.03-1.38-3.41,0-.89.24-1.78.73-2.59.57-.81,1.3-1.46,2.27-1.86.97-.41,2.35-.57,4.22-.57s3.41.16,4.54.57c1.13.41,1.95,1.05,2.51,1.86.65.81.89,1.78.89,2.84,0,1.22-.32,2.11-.97,2.84-.65.81-1.54,1.22-2.68,1.38h0ZM6.04,20.86c-1.05,0-1.95.24-2.51.81-.65.57-.97,1.22-.97,2.03s.41,1.54,1.05,2.11c.65.57,1.46.89,2.51.89.97,0,1.78-.24,2.35-.81.57-.57.89-1.3.89-2.19,0-.81-.32-1.54-.89-2.03-.57-.57-1.38-.81-2.43-.81h0Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Warning_Message",
    "data-name": "Warning Message"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background-3",
    "data-name": "Background"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.2-1.54l-.57-3.24,14.19-2.51c2.43-.41,4.46-.49,6-.16,1.54.24,2.92,1.05,4.05,2.35,1.22,1.3,2.03,3.16,2.43,5.51.41,2.27.32,4.22-.24,5.84-.49,1.62-1.46,2.84-2.84,3.73-1.46.89-3.41,1.54-6,2.03l-14.19,2.51-.65-3.24,14.19-2.51c2.19-.41,3.73-.89,4.62-1.46.97-.57,1.62-1.38,2.03-2.43.41-1.05.41-2.27.16-3.65-.41-2.43-1.22-4.05-2.51-4.86-1.22-.81-3.41-.89-6.49-.41L3.2-1.54Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "warning-triangle--frame-alert-warning-triangle-exclamation-caution"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    className: "cls-5",
    d: "M16.06,2.02c.56-.34,1.19-.52,1.84-.52s1.29.18,1.84.52c.56.34,1.01.83,1.3,1.41h0s0,.01,0,.01l12.97,25.94h0c.27.54.4,1.14.37,1.74-.03.6-.2,1.19-.52,1.7s-.76.94-1.28,1.23c-.53.3-1.12.45-1.72.45H4.93c-.6,0-1.2-.16-1.72-.45-.53-.3-.97-.72-1.28-1.23-.32-.51-.49-1.1-.52-1.7-.03-.6.1-1.2.37-1.74h0S14.75,3.43,14.75,3.43h0s0-.01,0-.01c.3-.58.75-1.07,1.3-1.41ZM17.9,11.21c.98,0,1.77.79,1.77,1.77v7.66c0,.98-.79,1.77-1.77,1.77s-1.77-.79-1.77-1.77v-7.66c0-.98.79-1.77,1.77-1.77ZM20.26,27.13c0,1.3-1.06,2.36-2.36,2.36s-2.36-1.06-2.36-2.36,1.06-2.36,2.36-2.36,2.36,1.06,2.36,2.36Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningSymbolWarningMessage);
export default __webpack_public_path__ + "static/media/Warning-Symbol_Warning-Message.d884b7f581fce6a988b549d2038016c6.svg";
export { ForwardRef as ReactComponent };